import TimelineFeed from '../../../components/Common/TimelineFeed/TimelineFeed'
import useFetchURL from '../../../elements/Hooks/useFetchURL'
import { isEmpty, get, sortBy, reverse } from 'lodash'
import moment from 'moment'
import React, { useState } from 'react'

function TimelineFeedCont(props) {
  const { owner, dependency = [false], hideNotification, submitNotification } = props
  const { data, fetching, fetchURL } = useFetchURL(
    `foxxapi/timeline?select=*&owner=${owner}`,
    [owner, ...dependency],
    isEmpty(owner),
    undefined,
    true
  )

  const postsPreSort = !isEmpty(data) ? data.filter((d) => d.type === 'parent') : []
  const posts = reverse(
    sortBy(postsPreSort, [
      function (o) {
        return moment(o.timestamp)
      },
    ])
  )

  const getPostReplay = (postId) => {
    const commentsPreSort = !isEmpty(data) ? data.filter((d) => get(d, 'post._id') === postId) : []
    return reverse(
      sortBy(commentsPreSort, [
        function (o) {
          return moment(o.timestamp)
        },
      ])
    )
  }

  const [show, setShow] = useState(false)
  const [showMain, setShowMain] = useState(false)

  function fetch() {
    fetchURL()
    setShow(false)
    setShowMain(false)
  }

  return (
    <TimelineFeed
      {...{
        submitNotification,
        posts,
        fetching,
        fetch,
        show,
        setShow,
        showMain,
        setShowMain,
        getPostReplay,
        hideNotification,
        owner,
      }}
    />
  )
}

export default TimelineFeedCont
